import { render, staticRenderFns } from "./Super.vue?vue&type=template&id=1e6fe5f4&"
import script from "./Super.vue?vue&type=script&lang=js&"
export * from "./Super.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports